import React from 'react'
import banner from '../../assets/Carousel/St Albans Banner 01.png'

const PhotoRestoration = () => {
  return (
    <div>
      <div className='relative w-full h-full mb-5 sm:mb-16'>
        <img src={banner} alt="offset banner"/>
        <div className='absolute top-0 w-full h-full bg-black/40 flex items-center justify-center'>
          <h1 className='text-2xl sm:text-4xl font-medium text-white drop-shadow-md'>Photo Restoration</h1>
        </div>
      </div>
      <div className='px-5 sm:px-10 pb-8 sm:pb-16'>
        
        <div className='px-4 md:px-14'>
          <div className='sm:px-4 py-6 lg:col-span-3 flex flex-col items-center'>
              <h1 className='text-3xl sm:text-4xl font-bold mb-4 sm:mb-8 text-neutral-800'>Photo Restoration</h1>
               <div className='flex flex-col gap-y-3 sm:gap-y-6 text-neutral-700 text-base sm:text-lg'>
  <p className='sm:leading-8'>
   Photographs serve as timeless treasures that capture invaluable memories, but they can fade, tear, or sustain damage over time. At St. Albans Digital Printing, we specialize in professional photo restoration in New York City, using advanced digital techniques and expert craftsmanship to revive your cherished images. Whether your photographs have experienced discoloration, scratches, water damage, or fading, our team guarantees high-quality restoration while maintaining the authenticity of the original image.
  </p> 

  <p className='sm:leading-8'>
  We meticulously restore each image, from vintage family portraits to historic photographs, enhancing clarity, correcting colors, and repairing any damage. Our restoration process preserves the integrity of the original while delivering improved detail and vibrancy. With cutting-edge technology and extensive experience, we rejuvenate old or damaged photographs, enabling you to share and preserve your memories for future generations. You have full control over your restoration project—bring us your damaged photographs, and we will evaluate their condition, offering expert recommendations.
  </p>

  <p className='sm:leading-8'>
   Our detailed process includes color correction, tear and crease repair, scratch removal, and background enhancements. We can also remove or replace backgrounds, colorize black-and-white images, and merge multiple photos into a single composition. Once restored, your images will be available in high-resolution digital formats or printed on premium archival paper for lasting preservation.
  </p>
<p className='sm:leading-8'>
   <p className='sm:leading-8'>
   Visit our website to learn more about our restoration services, or reach out for assistance. Call 718-528-5100, email orders@stalbansprinting.com, or stop by our St. Albans location to discuss your project in person. We recognize the sentimental value of your photographs, so all work is performed on-site, ensuring your original photo never leaves our shop. In some cases, we can even return your restored images on the same day!
  </p>
  </p>
  <p className='sm:leading-8'>
  <strong>Popular Photo Restoration Services</strong> 
  </p>
   <p className='sm:leading-8'>
   ➔	Vintage Photo Restoration: Reviving aged photographs to their original beauty.
  </p>
  <p className='sm:leading-8'>
  ➔	Tear & Crease Repair: Expertly mending damaged prints with precision.
  </p>
  <p className='sm:leading-8'>
  ➔	Colorization of Black & White Photos: Adding lifelike color to monochrome images.
  </p>
  <p className='sm:leading-8'>
  ➔	Faded Photo Enhancement: Reviving contrast and brightness in aged photos.
  </p>
  <p className='sm:leading-8'>
  ➔	Water & Stain Damage Repair: Removing marks and discoloration from spills or humidity. 
  </p>

  <p className='sm:leading-8'>
  ➔	Background Removal & Replacement: Replacing damaged or unwanted backgrounds.
  </p>
  <p className='sm:leading-8'>
  ➔	Photo Retouching for Headshots & Portraits: Enhancing details for actors, models, and professionals.
  </p>
  <p className='sm:leading-8'>
  ➔	Combining Multiple Photos: Merging elements from different images into one seamless composition.
  </p>
  <p className='sm:leading-8'>
  ➔	Digital Archiving & Printing: Providing high-resolution digital copies and premium prints using archival materials.
  </p>
  
        

        
</div>

              {/* --- Images from APi  */}
              <div>
                {/* ImageX3 in grid */}
              </div>
          </div>  
        </div>

      </div>
    </div>
  )
}

export default PhotoRestoration
